import React from "react";
import { Activity, CircleCheck, Clock3 } from "lucide-react";

import { cn } from "../../lib/utils";

export const REPORT_STAGE_GROUPS = Object.freeze([
  { value: "processing", label: "Processing", icon: Activity, tone: "processing" },
  { value: "delayed", label: "Delayed", icon: Clock3, tone: "delayed" },
  { value: "finished", label: "Finished", icon: CircleCheck, tone: "finished" },
]);

export function ReportStageGroupSelector({ value, onChange, disabled = false, className, ...props }) {
  return (
    <div className={cn("report-stage-group-selector", className)} role="group" aria-label="Report Stage Group" {...props}>
      {REPORT_STAGE_GROUPS.map(({ value: optionValue, label, icon: Icon, tone }) => {
        const selected = value === optionValue;
        return (
          <button
            key={optionValue}
            type="button"
            className={cn("report-stage-group-option", `report-stage-group-${tone}`, selected && "is-selected")}
            aria-pressed={selected}
            disabled={disabled}
            onClick={() => onChange?.(optionValue)}
          >
            <Icon aria-hidden="true" />
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
